import React from 'react';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';

import * as ShopSelectors from 'selectors/ShopSelectors';
import { FeaturedImage as FeaturedImageType, SliderValue } from 'common/modules/customization';
import FeaturedImage from 'common/components/customizer/FeaturedImage';
import GridItems from '../components/GridItems';

export interface Props {
	gridColumns: SliderValue | undefined;
	featuredImage: FeaturedImageType;
}
const CategoryListingView = (props: Props) => {
	const { gridColumns, featuredImage } = props;
	const language = useSelector(ShopSelectors.activeShopDefaultLanguage);

	return (
		<>
			{!!featuredImage && !!featuredImage.src && (
				<FeaturedImage
					featuredImage={featuredImage.src}
					alignment={featuredImage.alignment}
					heading={featuredImage.heading}
					description={featuredImage.description}
					button={featuredImage.button ?? null}
					isDeactivated={true}
					language={language}
				/>
			)}
			<Grid direction="row" alignItems="flex-start" container spacing={2}>
				<GridItems gridColumns={gridColumns} />
			</Grid>
		</>
	);
};

export default CategoryListingView;
